import React, { useState } from 'react';
import { toast } from 'react-toastify';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import useMain from '../../../hooks/useMain';
import http from '../../../services/httpService';
import jsonToFormData from '../../../utils/jsonToFormData';
import Preloader from '../../common/preloader';
import BlogForm from './blogForm';

function Create(props) {
	useDocumentTitle(['Create Blog']);
	const { onResetBlogs, initData, onUserDataChanged } = useMain();
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (formState) => {
		try {
			setIsLoading(true);
			const { data, images } = formState;

			const formData = jsonToFormData({
				title: data.title,
				description: data.description,
				tags: data.tags,
				domain: data.domain,
				publish: data.publish,
				story: data.story,
			});
			formData.append('img', images.img.length > 0 ? images.img[0].file : '');

			const response = await http.createBlog(formData);
			onUserDataChanged({ blogs: response.data.blogs });
			onResetBlogs();
			setIsLoading(false);
			props.history.push(`/blogs`);
		} catch (ex) {
			setIsLoading(false);
			console.log(ex);
			if (ex.response && (ex.response.status === 400 || 403)) {
				console.log(ex.response);
				toast.error(ex.response.data);
			}
		}
	};

	if (!initData.blogsConfig) return <Preloader />;
	return (
		<div className='container py-5'>
			<div className='row'>
				<h1 className='text-center mb-3'>Create New Blog</h1>
				<div className='card myCards'>
					<div className='card-body'>
						<BlogForm
							titleConfig={initData.blogsConfig.title}
							descriptionConfig={initData.blogsConfig.description}
							tagsConfig={initData.blogsConfig.tags}
							domainConfig={initData.blogsConfig.domains}
							maxFileSize={initData.blogsConfig.maxFileSize}
							acceptType={initData.blogsConfig.acceptType}
							onSubmit={handleSubmit}
							isLoading={isLoading}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Create;
